import {
  computed,
} from 'vue';
import { get } from '@utils/api';
import { usePageData } from '../usePageData';
import useFetch from '../api/useFetch';
import { useEnvProps } from '../useEnvProps';

/**
 * @returns {{
 *  reviewsPhotos: import('vue').ComputedRef<Review[]>,
 *  isLoading: import('vue').Ref<Boolean>,
 *  fetchReviewsWithPhotos: Function
 * }}
*/
export function useReviewsPhotos() {
  const { hostlink } = useEnvProps();
  const { productId } = usePageData();
  const url = `${hostlink}/xapi/digital/v1/product/${productId}/reviews?photosAndReviews=true&pageType=photocarousel&limit=10`;
  const { fetch, result, isLoading } = useFetch(() => get(url));

  const reviewsPhotos = computed(() => result.value?.review?.reviewsWithPhoto || []);

  return {
    fetchReviewsWithPhotos: () => {
      if (reviewsPhotos.value?.length <= 0) {
        fetch();
      }
    },
    reviewsPhotos,
    isLoading,
  };
}

export default useReviewsPhotos;
